import React from 'react'
import { BrowserRouter, Routes, Route } from "react-router-dom";
import LandingPage from '../modules/landing_page/pages/LandingPage';

function PageRouter() {
   
  return (
    <BrowserRouter>
    <Routes>

      {/* Landing Page */}
      <Route path="/" element={<LandingPage/>} />

      {/* Public User Dashboard */}
      {/* <Route path="/public_user" element={<PublicDashboard />}>
        <Route index element={<Home />} />
        <Route path="blogs" element={<Blogs />} />
        <Route path="contact" element={<Contact />} />
        <Route path="*" element={<NoPage />} />
      </Route> */}

      {/* Organization Dashboard */}
      {/* <Route path="/organization" element={<OrgDashboard />}>
        <Route index element={<Home />} />
        <Route path="blogs" element={<Blogs />} />
        <Route path="contact" element={<Contact />} />
        <Route path="*" element={<NoPage />} />
      </Route> */}

      {/* Super Admin Dashboard */}
      {/* <Route path="/super_admin" element={<AdminDashboard />}>
        <Route index element={<Home />} />
        <Route path="blogs" element={<Blogs />} />
        <Route path="contact" element={<Contact />} />
        <Route path="*" element={<NoPage />} />
      </Route> */}

    </Routes>
  </BrowserRouter>
  )
}

export default PageRouter